import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Button, Tooltip, } from 'antd';

import useDesignerMessage from "./hooks/useDesignerMessage";

export default function SiderController(props) {

    const [selectedSider, setSelectedSider] = useState();

    useDesignerMessage(e => {

        if (e.location !== props.location)
            return;

        setSelectedSider(e.name);

    }, "selectedSiderChanged");

    return <>
        {
            (props.addons || []).filter(c => c.location === props.location).map((c, i) => {
                return (
                    <div className={'sider-container ' + (selectedSider === c.name ? "shown" : "hidden")} >
                        <c.Component key={i + ""} {...c.props} metadata={c} />
                    </div>
                );
            })
        }
    </>
}